const jwtSelector = (state: any) => state.qs.jwt

export default jwtSelector
